// Navigation
$('#menu-toggle').click(function () {
    var $body = $('body'),
        $menu = $('.nav-container'),
        $hamburger = $('.hamburger');
    $body.toggleClass('menu-open')
    if ($body.hasClass('menu-open')) {
        $menu.addClass('menu-active');
        $hamburger.addClass('is-active');
    } else {
        $menu.removeClass('menu-active');
        $hamburger.removeClass('is-active');
    }
});

//Testimonials Slider
$('.glide').each(function () {
    const slider = new Glide(".glide", {
        type: "carousel",
        perView: 2,
        keyboard: true,
        breakpoints: {
            992: {
                perView: 1
            }
        }
    }).mount();
});

// function handleScrollOnResize() {
//     if ($(window).width() >= 992) {
//
//     } else {
//         $('.glide').each(function () {
//             const slider = new Glide(".glide", {
//                 type: "carousel",
//                 perView: 1,
//                 keyboard: true,
//             }).mount();
//         });
//     }
//
// }
//

$(document).ready(function () {
    if ($('#modal-summoning-btn').length) {
        showModal();
    }

// Change Recaptcha error message
    if ($('.field.nocaptcha .message.error').length) {
        changeErrMsg();
    }
});

function changeErrMsg() {
    let targetParent = $('.nocaptcha')
    let target;

    if (targetParent.children('.message.error').length) {
        let target = targetParent.children('.message.error');
        target.text('Verification failed. Please try to verify again.');
    }
}

function showModal() {
    let formContainer = $('.centre-assessment-form-container');
    let centreModBtn = $('#modal-summoning-btn');
    let modForm = $('#mod-form-container');
    let overlay = formContainer.children('.overlay')

    centreModBtn.on('click', function () {
        if (modForm.hasClass('no-show')) {
            modForm.removeClass('no-show');
            overlay.removeClass('no-show');
        }
    });

    // Listen for clicks on the overlay
    overlay.on('click', function (e) {
        // Check if the click is outside the modForm or on the overlay
        if (!modForm.is(e.target) && modForm.has(e.target).length === 0) {
            modForm.addClass('no-show');
            overlay.addClass('no-show');
        }
    });
}
